const AddButton = ({ onClick, title, fontSize = "20px" }) => {
  return (
    <div className="card border-0">
      <div className="tab-content p-3">
        <div className="tab-pane fade show active" id="allTab"></div>

        <div
          style={{
            height: "400px",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
        >
          <div
            className="d-flex justify-content-center"
            style={{
              width: "147px",
              height: "140px",
              border: "2px dashed #408FA0",
              borderRadius: "20px",
              padding: "15px",
            }}
          >
            <div
              className=""
              style={{
                width: "125px",
                height: "108px",
                backgroundColor: "#F5F5F5",
                borderRadius: "20px",
                cursor: "pointer",
              }}
              onClick={onClick}
            >
              <i
                className="fa fa-plus mt-3 d-flex justify-content-center"
                style={{ fontSize: "35px", color: "#408FA0" }}
              ></i>
              <br />
              <span
                className="d-flex justify-content-center align-item-center"
                style={{
                  font: "OpenSans",
                  fontSize: fontSize, 
                  color: "#408FA0",
                }}
              >
                {title}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddButton;